import React, { Component } from 'react';
import { Row, Col, Card, CardBody, ButtonGroup, Button } from 'reactstrap';

//Import Charts
import { RevenueAnalyticsChart } from './Charts'
import "./dashboard.scss";
import ReactApexChart from 'react-apexcharts';

class SalesAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [
                // {
                //     name: 'sales',
                //     data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                // }
            ],
            options: {
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    type: 'category',
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false,
                },
                grid: {
                    show: true, // Enable grid
                    xaxis: {
                        lines: {
                            show: true // Show vertical grid lines,
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                    // strokeDashArray: 5 // show dotted line (too fade)
                },
                fill: {
                    type: 'gradient'
                },
                stroke: {
                    curve: 'smooth',
                },
                colors: ['#E7515A'],
                noData: {
                    text: 'No Data',
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined
                    }
                }
            },

        }
    }
    componentDidMount() {
        if (this.props?.sales) {
            let salesData = []
            Object.keys(this.props.sales).forEach(key => {
                salesData.push(this.props.sales[key])
            });
            this.setState({
                series: [
                    {
                        name: 'sales',
                        data: salesData
                    }
                ]
            })
        }
    }
    componentDidUpdate() {
        if (this.state.series?.length < 1 && this.props?.sales) {
            let salesData = []
            Object.keys(this.props.sales).forEach(key => {
                salesData.push(this.props.sales[key])
            });
            this.setState({
                series: [
                    {
                        name: 'sales',
                        data: salesData
                    }
                ]
            })
        }
    }
    renderGraph() {
        return (
            <div id="line-column-chart" className="apex-charts" dir="ltr">
                <ReactApexChart options={this.state.options} series={this.state.series} type="area" height="340" />
            </div>
        )
    }
    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardBody style={{ minHeight: 466 }}>
                        <div className="graph-header mb-2">Sales Over Time</div>
                        <div className=" mb-2">Total Sales (S$)
                            <span style={{ color: '#4361EE', marginLeft: 10 }}>{this?.props?.totalSales}</span>
                        </div>
                        {
                            this.renderGraph()
                        }
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default SalesAnalytics;